import React, { useState, useContext, useEffect, useRef } from "react";
import "../../styles/offsetting.css";
import loader2 from "../../images/loader_2.gif";
import ApiService from "../../api/apiService";
import showSwal from "../swal";
import { common } from "../../util/common";
import { convertTo12HourPlusDateFormat } from "../../util/helperFunctions";
import "../../styles/ccar-form.css";

function OffsettingForm({ formDetails, setReferenceId, setDateAndTime, setFormSubmitted }) {
  const loaderRef = useRef(null);

  const [isSubmitting, setSubmitting] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");

  const [images, setImages] = useState(null);

  const [formData, setFormData] = useState({
    specificAddress: "",
    companyName: "",
    contactName: "",
    position: "",
    mobileNumber: null,
    telephone1: null,
    telephone2: null,
    supplier: null,
    volume: null,
    prospectsEmail: null,
  });

  const handleImageChange = (event) => {
    const files = event.target.files;
    setImages(files);
  };

  const handleDataChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleRegionChange = (event) => {
    setSelectedRegion(event.target.value);
    setSelectedProvince("");
  };

  const departments = ["Finance", "Sales", "Warehouse / Supply Chain", "Customer Fulfillment and Delivery", "Other"];
  const ncSources = ["Delivery (Customer Complaint)", "Quality (Customer Complaint)", "Audit", "Incident Report"];
  const warehouses = [
    "Bacolod",
    "Bohol",
    "Cavite Depot",
    "NCR",
    "Ormoc",
    "Starport Mindoro",
    "Tacloban",
    "Top Armada Mindoro",
    "Other",
  ];

  const handleSubmit = async (e) => {
    const {
      specificAddress,
      companyName,
      position,
      mobileNumber,
      telephone1,
      telephone2,
      supplier,
      volume,
      prospectsEmail,
    } = formData;

    const _formData = new FormData();
    _formData.append("specificAddress", specificAddress);
    _formData.append("companyName", companyName);
    _formData.append("position", position);
    _formData.append("mobileNumber", mobileNumber);
    _formData.append("telephone1", telephone1);
    _formData.append("telephone2", telephone2);
    _formData.append("supplier", supplier);
    _formData.append("volume", volume);
    _formData.append("prospectsEmail", prospectsEmail);

    if (images) {
      for (let i = 0; i < images.length; i++) {
        _formData.append("prospectingImages", images[i]);
      }
    }

    e.target.style.display = "none";
    loaderRef.current.style.display = "inline-block";

    const response = await ApiService.forms.submitProspectingRequest(formDetails.id, _formData);
    const { success, prospecting } = response;
    if (!success) return showSwal(common.errors.SUBMIT_OFFSET_FORM_ERROR);
    setSubmitting(false);
    e.target.style.display = "block";
    loaderRef.current.style.display = "none";
    setReferenceId(prospecting.reference_id);
    setDateAndTime(convertTo12HourPlusDateFormat(prospecting.createdAt));
    setFormSubmitted(true);
  };

  return (
    <div className='epr-form-container'>
      <div className='epr-title'>
        <h3>Customer Corrective Action Request Form</h3>
      </div>
      <div className='epr-form-body'>
        <div className='epr-form-groupings'>
          <div className='epr-form-group'>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor='region'>
                Issued to<span className='epr-required'>*</span>
              </label>
              <select name='region' id='region' value={selectedRegion} onChange={handleRegionChange}>
                <option value=''>Select Department</option>
                {departments.map((department, index) => (
                  <option value={department} key={`${index}-${department}`}>
                    {department}
                  </option>
                ))}
              </select>
            </div>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor='region'>
                NonConformity (NC) Source<span className='epr-required'>*</span>
              </label>
              <select name='region' id='region' value={selectedRegion} onChange={handleRegionChange}>
                <option value=''>Select Source</option>
                {ncSources.map((ncSource, index) => (
                  <option value={ncSource} key={`${index}-${ncSource}`}>
                    {ncSource}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='epr-form-group'>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor='region'>
                Warehouse<span className='epr-required'>*</span>
              </label>
              <select name='region' id='region' value={selectedRegion} onChange={handleRegionChange}>
                <option value=''>Select Warehouse</option>
                {warehouses.map((warehouse, index) => (
                  <option value={warehouse} key={`${index}-${warehouse}`}>
                    {warehouse}
                  </option>
                ))}
              </select>
            </div>

            <div className='epr-form-fields-prospecting'>
              <label htmlFor=''>Customer / Audit Reference Number</label>
              <input
                type='text'
                onChange={(e) => handleDataChange("specificAddress", e.target.value)}
                placeholder='Audit Report No., Process & Quality Reports No., Customer Complaint Form No., etc.'
              />
            </div>
          </div>
          <div className='epr-form-group'>
            <div className='epr-title'>
              <h3>Pagtugon sa NC</h3>
            </div>
            <div className='epr-form-group'>
              <div className='epr-form-fields-prospecting'>
                <label htmlFor=''>A. Pagsalaysay sa Paltos (NC) na Delivery or Quality</label>
                <textarea
                  onChange={(e) => handleDataChange("specificAddress", e.target.value)}
                  placeholder='Description of NonConformity (NC)- Detailed description/ Illustration of NC (What, When, Where, How Big, etc.)'
                />
              </div>
            </div>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor='images'>Image Upload</label>
              <input type='file' id='images' multiple onChange={handleImageChange} />
            </div>
          </div>
        </div>
        <div className='epr-submit-action-btn'>
          <button className='epr-submit-request' onClick={(e) => handleSubmit(e)}>
            <span className='epr-form-btn-txt'>Submit Request</span>
            <img src={loader2} className='epr-form-loader' style={{ display: "none" }} ref={loaderRef} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default OffsettingForm;
